// extracted by mini-css-extract-plugin
module.exports = {"nickname_field":"customer_nickname-nickname_field__3mAgi"};